import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
  selector: '[app-email-validator][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CustomEmailValidator,
      multi: true
    }
  ]
})
export class CustomEmailValidator implements Validator {

  // tslint:disable-next-line:max-line-length
  public static readonly emailRegexp: RegExp = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/;
  validate(c: AbstractControl): ValidationErrors | null {
    return !c.value || CustomEmailValidator.emailRegexp.test(c.value) ? null : {emailValidator: 'Email address ' + c.value + ' is invalid'};
  }

}
